import { progressInstance } from "@nx-paeonia/utils-events";
import { type Ref, ref, type ShallowRef, shallowRef } from "vue";

type UseFetchReturn<T> = {
	data: ShallowRef<T | null>;
	error: Ref<Error | null>;
	loading: Ref<boolean>;
	execute: (url: string, options?: RequestInit) => Promise<void>;
};

type UseFetchConfig = {
	showLoadingBar?: boolean;
};

export function useFetch<T extends object>(config?: UseFetchConfig): UseFetchReturn<T> {
	const data: UseFetchReturn<T>["data"] = shallowRef<T | null>(null);
	const error = ref<Error | null>(null);
	const loading = ref(false);

	async function execute(url: string, options: RequestInit = {}) {
		if (config?.showLoadingBar) {
			progressInstance.start();
		}
		loading.value = true;
		error.value = null;
		try {
			const res = await fetch(url, options);
			if (!res.ok) throw new Error(`HTTP ${res.status}`);
			data.value = (await res.json()) as T;
		} catch (e) {
			error.value = e instanceof Error ? e : new Error(String(e));
		} finally {
			loading.value = false;
			progressInstance.done();
		}
	}

	return { data, error, loading, execute };
}
